import { Typography } from '@automata/ui';
import WarningAmber from '@mui/icons-material/WarningAmber';
import { List, ListItem } from '@mui/material';
import Box from '@mui/material/Box';

import { TaskDependencyError } from '../../../features/selectors';
import { TASK_DEPENDENCY_ERRORS_TEXT } from '../../../text/taskDependencyErrors';
import CustomWidthTooltip from '../../CustomWidthTooltip';

const InvalidDependencyWarning = ({
  errors,
}: {
  errors: TaskDependencyError[];
}): JSX.Element => (
  <CustomWidthTooltip
    title={
      <Box p={2}>
        <Typography variant="subtitle1" component="h6">
          Invalid Dependency
        </Typography>
        <List sx={{ listStyleType: 'disc', p: 0 }}>
          {errors.map((error) => (
            <ListItem key={error} sx={{ display: 'list-item', pl: 1, ml: 2 }}>
              <Typography variant="body2">
                {TASK_DEPENDENCY_ERRORS_TEXT[error]}
              </Typography>
            </ListItem>
          ))}
        </List>
      </Box>
    }
    placement="bottom-end"
  >
    <WarningAmber color="error" />
  </CustomWidthTooltip>
);

export default InvalidDependencyWarning;
